import { debug, type DropdownProps, type DropdownItem } from 'light-component';
import { useState, type ReactElement, type ChangeEvent } from 'react';
import { Dropdown, Input, type MenuProps } from 'antd';
import { Box } from '../../box';
import { Block } from '../../block';
import { t } from '../../i18n';
import styles from './style.module.less';
import { WidgetNoData } from './widget-nodata';

export function WidgetGridDropdown(props: DropdownProps): ReactElement {
  debug.widget('dashboard gridDropdown', props);
  const [searchValue, setSearchValue] = useState<string>('');
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(props.value ?? '');
  const items: MenuProps['items'] = props?.options?.map(item => {
    if (item.type === 'divider') {
      return { type: 'divider' };
    }
    return {
      label: t(item.title),
      key: item.value,
      icon: item.icon,
      onClick: () => item.onClick?.(item)
    };
  }) ?? [];

  const onSearchChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const { value } = event.target;
    setSearchValue(value);
  };

  const filterOptions = (): { key: string; label: string }[] => {
    if (items == null) {
      return [];
    }
    if (searchValue === '') {
      return items as { key: string; label: string }[];
    }

    return items?.filter(item => (
      item as { label: string }
    )?.label.includes?.(searchValue)) as { key: string; label: string }[];
  };

  const onSelect = (key: string): void => {
    setOpen(false);
    setSelected(key);
    props.onSelect?.(key);
  };

  const role = (props.options ?? [])?.find(item => item.value === props.value) as DropdownItem;
  return (
    <div className={styles.gridDropDown}>
      <Dropdown
        open={open}
        menu={{ items }}
        trigger={['click']}
        overlayClassName={styles.dropDownOverlay}
        onOpenChange={(open: boolean) => {
          setOpen(open);
        }}
        placement='bottomRight'
        dropdownRender={() => (
          <Box className={styles.folderContainer}>
            <Block if={items.length > 10}>
              <Box className={styles.folderSearch}>
                <Input
                  value={searchValue}
                  placeholder={t('搜索')}
                  onChange={onSearchChange}
                />
              </Box>
            </Block>
            <Block if={items.length === 0}>
              <div className={styles.noData}>
                <WidgetNoData />
              </div>
            </Block>
            <Block if={items.length > 0}>
              <Box className={styles.gridList}>
                {
                  filterOptions().map(option => (
                    <Box
                      key={option?.key}
                      className={`${styles.gridItem} ${selected === option.key ? styles.active : ''}`}
                      onClick={() => onSelect(option.key)}
                    >
                      {t(option.label)}
                    </Box>
                  ))
                }
              </Box>
            </Block>
          </Box>
        )}
      >
        <Input
          value={role != null ? t(role.title) : ''}
          placeholder={props.placeholder ?? t('点此选择角色')}
        />
      </Dropdown>
    </div>
  );
}

